// import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { caseActions } from '../../../../store/case'
import CardGrey from '../../../common/CardGrey'
import CheckboxCell from '../../../common/interactive/CheckboxCell'
import { caseQuickUpdate } from '../../../../lib/fetchApi'
import { notificationActions } from '../../../../store/notifications'
import InputBox from '../../../common/interactive/InputBox'
import FundsBox from '../../../common/FundsBox'
import InputBoxCurrency from '../../../common/interactive/InputBoxCurrency'
import { retrieveTransportaionsData } from '../../../../lib/systemData'
import Button from '../../../common/Button'
import { formatCurrency } from '../../../../lib/script'

import classes from '../Shared/Item.module.css'
import { useUserTabEditPermissionDisabled } from '../../../../lib/usersPermissions'
import { useState } from 'react'
import { filterActions } from '../../../../store/filter'

const TransportationSidebar = ({data, apiCase, inWorkQ}) => {
    let userPermission = useUserTabEditPermissionDisabled('transportation_topup_funds')
    let userPermissionDenyTrip = useUserTabEditPermissionDisabled('transportation_deny_further_trips')

    const [increaseLoading, setIncreaseLoading] = useState(false)
    const [decreaseLoading, setDecreaseLoading] = useState(false)

    const dispatch = useDispatch()

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 

    // const [totalRidesCharges, setTotalRidesCharges] = useState(0)
    let transportationSystemData = retrieveTransportaionsData()

    const updateHandler = async (value, increaseLoading, decreaseLoading) => {
        if (increaseLoading) {
            setIncreaseLoading(true)
        }
        if (decreaseLoading) {
            setDecreaseLoading(true)
        }
        let dispatchObj = {
            folder: value.identifier.folder,
            item: {
                fields: [
                    {
                        field: value.identifier.field,
                        value: value.data.value
                    },
                ]            
            }
        }

        
        
        setTimeout(() => {
            dispatch(caseActions.modifyActiveCaseMultipleObject(dispatchObj))
        }, 0)

        const body = {
            type: value.identifier.type,
            fields: {
                [value.identifier.field]: value.data.value
            }    
        }
       
        const update = await caseQuickUpdate(userToken, activeCase.case.id, body, dispatch, !!inWorkQ)
        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        } else {
            if (inWorkQ) {
                // convert fields object to array of objects, if it's an object
                let fields = []
                if (update && update.caseData && update.caseData.case_transportation  && !Array.isArray(update.caseData.case_transportation) && typeof update.caseData.case_transportation === 'object') {
                    fields = Object.entries(update.caseData.case_transportation).map(([field, value]) => ({ field, value }));
                }

                let dispatchObjInWorkQ = {
                    case_id: inWorkQ.case.id,
                    folder: value.identifier.folder,
                    item: {
                        fields: fields           
                    }
                }
                dispatch(filterActions.updateItemInWorkQRow(dispatchObjInWorkQ))
            } 
        }
        
        if (increaseLoading) {
            setIncreaseLoading(false)
        }
        if (decreaseLoading) {
            setDecreaseLoading(false)
        }
    }

    function topUpHandler() {
        let identifier = {type: apiCase, field: 'top_up_increment', folder: 'case_transportation'} 
        let value = {
            data: {
                value: retrieveTransportaionsData()?.top_up_increment
            },
            identifier: identifier
        }
        updateHandler(value, true, null)
    }

    function decreaseTopUpHandler() {
        let identifier = {type: apiCase, field: 'top_up_increment', folder: 'case_transportation'} 
        let value = {
            data: {
                value: -Number(retrieveTransportaionsData()?.top_up_increment)
            },
            identifier: identifier
        }
        if (data.funds_remaining <= 0 || data.funds_remaining == null || data.funds_remaining < retrieveTransportaionsData()?.minimum_charge) {
            dispatch(notificationActions.setError({errorMessage: 'Funds Remaining is less than the minimum charge'}))
            return
        }
        updateHandler(value, null, true)
    }

    return <CardGrey minHeight={'100%'}>
        <div className={classes.container}>
            <div className={classes.sidebar_row_block}>
                <CheckboxCell checked={data.has_contract_signed} direction={'reverse'} label={'Contract Signed'} name={'has_contract_signed'}  action={updateHandler} identifier={{type: apiCase, field: 'has_contract_signed', folder: 'case_transportation'}}/>
            </div>
            <div className={classes.sidebar_row_block}>
                <InputBox label={'Client Number'} currentValue={data.client_number} action={updateHandler} identifier={{type: apiCase, field: 'client_number', folder: 'case_transportation'}} isNotModifiable={true}/>
            </div>     
        </div>

        <div className={classes.sidebar_container_border}>
            
            <div className={classes.sidebar_row}>
                <div className='flex-container flex_full gap-8'>
                    <FundsBox label={'Funds Remaining'} value={`$${formatCurrency(data.funds_remaining)}`} color={data.funds_remaining < Number(transportationSystemData?.minimum_funds_remaining) ? 'red' : ''}/>
                    {/* <InputBoxCurrency action={updateHandler} label={'Funds Remaining'} currentValue={data.funds_remaining} name={'funds_remaining'} identifier={{type: apiCase, field: 'funds_remaining', folder: 'case_transportation'}} fullBox={true} /> */}
                    <FundsBox label={'Total Charges'} value={`$${formatCurrency(data.total_charges)}`} />
                </div>
                
            </div>           
            <div className={classes.sidebar_row}>
                <InputBoxCurrency label={'Total Approved'} currentValue={data.total_approved ? data.total_approved : retrieveTransportaionsData()?.minimum_approved_amount} name={'total_approved'} identifier={{type: apiCase, field: 'total_approved', folder: 'case_transportation'}} fullBox={true} isNotModifiable={true}/>

            {userPermission && <div className={classes.transportation_btn_container}>
                <Button click={topUpHandler} btnStyle={'btn_small'} isLoading={increaseLoading}>+</Button>
                <Button click={decreaseTopUpHandler} btnStyle={'btn_small'} isLoading={decreaseLoading} isDisabled={data.funds_remaining <= 0 || data.funds_remaining == null || data.funds_remaining < retrieveTransportaionsData()?.minimum_charge}>-</Button>
            </div>}
            </div>
            <div className={classes.sidebar_row}>
                {/* isNotModifiable={true} */}
                <InputBoxCurrency isNotModifiable={true} label={'Avg. Round Trip'} currentValue={Number(data.avg_trip_amount) * 2} name={'avg_trip_amount'} identifier={{type: apiCase, field: 'avg_trip_amount', folder: 'case_transportation'}} fullBox={true} />
            </div>
                      
        </div>

        {userPermissionDenyTrip && <div className={classes.sidebar_footer}>
            <CheckboxCell checked={data.deny_further_trips} direction={'reverse'} label={'Deny further trips'} name={'deny_further_trips'}  action={updateHandler} identifier={{type: apiCase, field: 'deny_further_trips', folder: 'case_transportation'}}/>
        </div>}
    </CardGrey>
}

export default TransportationSidebar